import {
  CLEAR_SALESPERSON, RESET_SEARCH_OBJ,
  RESET_SIMULATED_BUSINESS_ACTIVITIES,
  RESET_SIMULATED_USER_DETAILS,
  SET_SIMULATE_MODE,
} from "../action.js";

export function setIsSimulateMode(value) {
  return (dispatch) => {
    dispatch({ type: SET_SIMULATE_MODE, payload: value });
    if (!value) {
      dispatch({ type: RESET_SIMULATED_BUSINESS_ACTIVITIES });
      dispatch({ type: CLEAR_SALESPERSON });
      dispatch({ type: RESET_SIMULATED_USER_DETAILS });
      dispatch({type: RESET_SEARCH_OBJ});
    }
  };
}
